// extracted by mini-css-extract-plugin
module.exports = {"aboutLpContainer":"page_aboutLpContainer__IzYGh"};